import { useMyRole } from '@/shared/hooks/useMyRole';
import type { TeamRole } from '@/shared/services/team.service';

/** Roles the API lets create and change content (posts, templates, media, slots). */
const WRITE_ROLES: ReadonlySet<TeamRole> = new Set(['owner', 'admin', 'editor']);

export interface CanWrite {
  /** Owner, admin or editor. True until the role is known, so a writer never sees controls flicker away. */
  canWrite: boolean;
  /** The role is known and is a viewer or a client: show the review view, not the controls the API refuses. */
  readOnly: boolean;
  role: TeamRole | null;
}

/**
 * Whether the signed-in person may write on the brand in view (PC-26).
 * Viewers and clients (CLIENT_VIEWER) read and, for clients, approve; every
 * write the API refuses them is hidden or disabled instead of failing.
 */
export function useCanWrite(): CanWrite {
  const { role, isLoading } = useMyRole();
  const known = role !== null || !isLoading;
  const canWrite = !known || role === null ? true : WRITE_ROLES.has(role);
  return { canWrite, readOnly: !canWrite, role };
}
